import React, { useState, useEffect } from "react";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import AutoCompleteMultiSelect from "../autoCompleteComponent/AutoCompleteMultiSelect";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Grid,
  TextField,
} from "@mui/material";
import { Field, Form, Formik, getIn, ErrorMessage, FieldArray } from "formik";
import * as yup from "yup";
import { connect } from "react-redux";
import MuiButton from "../muiButton/MuiButton";
import MuiTextField from "../muiTextField/MuiTextField";
import LockIcon from "@mui/icons-material/Lock";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import InfluencerUserAction from "../../stores/influencerUser/InfluencerUserAction";
import SwitchButton from "../../components/switchComponent/SwitchButton";
import DatePickerComponent from "../../components/datePickerComponent/DatePickerComponent";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

// mapstateto props function

const mapDispatchToProps = (dispatch) => {
  return "ok";
};

function ManageInfluenceUserPost(props) {
  const [showPassword, setShowPassword] = React.useState(false);
  const buttonForLoginRef = React.useRef(null);

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const { token } = props;

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const MartialArray = ["Married", "single", "widower", "Do not want to share"];

  function setCustomFieldValueType(data) {
    if (data === "text") {
      return [{ value: "", id: "" }];
    } else if (data === "select") {
      return [{ value: "", id: "" }];
    } else if (data === "date") {
      return [{ value: "", id: "" }];
    } else if (data === "multiselect") {
      return [];
    } else if (data === "radio") {
      return [{ value: "", id: "" }];
    } else if (data === "toggle") {
      return [{ value: "", id: "" }];
    } else {
      return [];
    }
  }

  let custom_value = [];
  if (props.customticketfields) {
    props.customticketfields.hits &&
      props.customticketfields.hits.hits &&
      props.customticketfields.hits.hits.map((item) => {
        return custom_value.push({
          field_id: item._id,
          field_name: item._source.field_name,
          field_type: item._source.field_type,
          field_values: setCustomFieldValueType(item._source.field_type),
        });
      });
  }
  let customFieldInitialValues = [];
  if (custom_value.length != 0) {
    customFieldInitialValues = custom_value;
  }

  //Initial values
  let initial = {};
  if (props.edit) {
    initial = {
      influencer_name: props.userEditData.influencer_name
        ? props.userEditData.influencer_name
        : "",
      firstName: props.userEditData.firstName
        ? props.userEditData.firstName
        : "",
      lastName: props.userEditData.lastName ? props.userEditData.lastName : "",
      age: props.userEditData.age ? props.userEditData.age : "",
      gender: props.userEditData.gender ? props.userEditData.gender : "",
      marital_status: props.userEditData.marital_status
        ? props.userEditData.marital_status
        : "",
      languages: props.userEditData.languages
        ? props.userEditData.languages
        : "",
      influencer_description: props.userEditData.influencer_description
        ? props.userEditData.influencer_description
        : "",
      contact_number: props.userEditData.contact_number
        ? props.userEditData.contact_number
        : "",
      email_address: props.userEditData.email_address
        ? props.userEditData.email_address
        : "",
      social_media_platforms: props.userEditData.social_media_platforms_array
        ? props.userEditData.social_media_platforms_array
        : "",
      audience_size: props.userEditData.audience_size
        ? props.userEditData.audience_size
        : "",
      total_post: props.userEditData.total_post
        ? props.userEditData.total_post
        : "",
      pricing: props.userEditData.pricing ? props.userEditData.pricing : "",
      category: props.userEditData.category ? props.userEditData.category : "",
      location: props.userEditData.location ? props.userEditData.location : "",
      status: props.userEditData.status ? props.userEditData.status : "",
      influencer_score: props.userEditData.influencer_score
        ? props.userEditData.influencer_score
        : "",
      enabled: props.userEditData.enabled === "Enabled" ? true : false,
      organization: props.userEditData.organization_obj
        ? props.userEditData.organization_obj
        : "",
      custom_value: props.userEditData.custom_fields && [
        ...props.userEditData.custom_fields,
      ],
    };
  } else {
    initial = {
      influencer_name: "",
      firstName: "",
      lastName: "",
      age: "",
      gender: "",
      marital_status: "",
      languages: "",
      influencer_description: "",
      contact_number: "",
      email_address: "",
      social_media_platforms:
        props.platformList.length === 1 ? props.platformList[0] : [],
      audience_size: "",
      total_post: "",
      pricing: "",
      category:
        props.category_array.length === 1 ? props.category_array[0] : [],
      location: "",
      status: props.statuslist.length === 1 ? props.statuslist[0] : "",
      influencer_score: "",
      enabled: true,
      credentials: [{ type: "password", value: "", temporary: false }],
      organization:
        props.organization_array.length === 1
          ? props.organization_array[0]
          : "",
      custom_value: customFieldInitialValues,
    };
  }

  const [loading, setLoading] = React.useState(false);

  return (
    <Dialog open={props.open} onClose={props.onClose} fullWidth maxWidth="md">
      <Formik
        initialValues={initial}
        validate={(values) => {
          var errors = {};
          if (!values.influencer_name) {
            errors.influencer_name = "Influencer Name is Required";
          }
          if (!values.firstName) {
            errors.firstName = "FirstName is Required";
          }
          if (!values.lastName) {
            errors.lastName = "LastName is Required";
          }
          if (!values.age) {
            errors.age = "Age is Required";
          }

          if (!values.gender) {
            errors.gender = "Gender is Required";
          }

          if (!values.marital_status) {
            errors.marital_status = "Marital status is Required";
          }

          if (!values.languages) {
            errors.languages = "Languages is Required";
          }

          if (!values.influencer_description) {
            errors.influencer_description = "Description is Required";
          }

          if (!values.contact_number) {
            errors.contact_number = "Contact number is Required";
          }

          if (!values.email_address) {
            errors.email_address = "Email address is Required";
          }

          if (!values.social_media_platforms.length) {
            errors.social_media_platforms = "Platforms are Required";
          }
          if (!values.audience_size) {
            errors.audience_size = "Audience size is Required";
          }
          if (!values.total_post) {
            errors.total_post = "Total number of posts are Required";
          }
          if (!values.pricing) {
            errors.pricing = "Pricing is Required";
          }

          if (!values.category.length) {
            errors.category = "Category is Required";
          }
          if (!values.organization) {
            errors.organization = "Organization is Required";
          }

          if (!values.location) {
            errors.location = "Location is Required";
          }

          if (!values.status) {
            errors.status = "Status is Required";
          }

          if (!values.influencer_score) {
            errors.influencer_score = "Influencer score is Required";
          }
          if (!values.status) {
            errors.status = "Status is Required";
          }

          if (!props.edit && !values.credentials[0].value) {
            errors.credentials = "Password is Required";
          }

          return errors;
        }}
        onSubmit={(values, formikHelpers) => {
          setLoading(true);

          let obj_edit_data = {};

          Object.assign(
            obj_edit_data,
            values.influencer_name && {
              influencer_name: values.influencer_name,
            },
            values.firstName && { firstName: values.firstName },
            values.lastName && { lastName: values.lastName },
            values.age && { age: values.age },
            values.gender && { gender: values.gender },
            values.marital_status && { marital_status: values.marital_status },
            values.languages && { languages: values.languages },
            values.influencer_description && {
              influencer_description: values.influencer_description,
            },
            values.contact_number && { contact_number: values.contact_number },
            values.email_address && { email_address: values.email_address },
            values.social_media_platforms && {
              social_media_platforms: values.social_media_platforms,
            },
            values.audience_size && { audience_size: values.audience_size },
            values.total_post && { total_post: values.total_post },
            values.pricing && { pricing: values.pricing },
            values.category && { category: values.category },
            values.location && { location: values.location },
            values.status && { status: values.status.status_id },
            values.influencer_score && {
              influencer_score: values.influencer_score,
            },
            values.custom_value && {
              custom_fields: values.custom_value,
            },
            { enabled: values.enabled },
            values.organization && {
              attributes: {
                organization_id: values.organization.organization_id,
              },
            }
          );

          // parameter for showing list based on the modified_by
          const params = {
            page_limit: "none",
            order_by: '[["modified_on", "desc"]]',
          };
          if (props.edit) {
            props
              .dispatch(
                InfluencerUserAction.requestPutInfluencerUser(
                  obj_edit_data,
                  props.userEditData.id
                )
              )
              .then(() => {
                props.dispatch(
                  InfluencerUserAction.requestInfluencerUser(params)
                );
                props.dispatch(
                  InfluencerUserAction.requestInfluencerUserFilter(params)
                );
                props.onClose();
                setLoading(false);
              });
          }

          // ****************************************   Post method
          else {
            let obj_post_data = {};

            Object.assign(
              obj_post_data,
              values.influencer_name && {
                influencer_name: values.influencer_name,
              },
              values.firstName && { firstName: values.firstName },
              values.lastName && { lastName: values.lastName },
              values.age && { age: values.age },
              values.gender && { gender: values.gender },
              values.marital_status && {
                marital_status: values.marital_status,
              },
              values.languages && { languages: values.languages },
              values.influencer_description && {
                influencer_description: values.influencer_description,
              },
              values.contact_number && {
                contact_number: values.contact_number,
              },
              values.email_address && {
                email_address: values.email_address,
              },
              values.social_media_platforms && {
                social_media_platforms: values.social_media_platforms,
              },
              values.audience_size && {
                audience_size: values.audience_size,
              },
              values.total_post && { total_post: values.total_post },
              values.pricing && { pricing: values.pricing },
              values.category && { category: values.category },
              values.location && { location: values.location },
              values.status && { status: values.status.status_id },
              values.influencer_score && {
                influencer_score: values.influencer_score,
              },
              { enabled: values.enabled },
              values.credentials && {
                credentials: values.credentials,
              },
              values.organization && {
                attributes: {
                  organization_id: values.organization.organization_id,
                },
              },
              values.custom_value && {
                custom_fields: values.custom_value,
              }
            );

            const callBack = () => {
              props.onNavigateCampaign(obj_edit_data.influencer_name);
            };

            props
              .dispatch(
                InfluencerUserAction.requestPostInfluencerUser(
                  obj_post_data,
                  callBack
                )
              )
              .then(() => {
                const params = {
                  order_by: '[["created_on", "desc"]]',
                  page_limit: "none",
                };
                props.dispatch(
                  InfluencerUserAction.requestInfluencerUser(params)
                );
                props.dispatch(
                  InfluencerUserAction.requestInfluencerUserFilter(params)
                );
                props.onClose();
                setLoading(false);
              });
          }

          // formikHelpers.resetForm();
        }}
      >
        {({ values, errors, isValid, touched, dirty, handleChange }) => (
          <Form>
            <DialogContent
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <DialogContentText sx={{ width: "80%" }}>
                <div className="text-center pb-2">
                  <div className="row p-3">
                    <div className="col-11">
                      <h3 className="dailogtext">
                        <b>
                          {!props.edit ? (
                            <>
                              <span className="span_first_letter">A</span>dd{" "}
                            </>
                          ) : (
                            <>
                              <span className="span_first_letter">E</span>dit
                            </>
                          )}
                          <span className="span_first_letter">I</span>nfluencers{" "}
                        </b>{" "}
                      </h3>
                    </div>
                    <div className="col-1 closebtn">
                      <i
                        className="fa fa-times-circle-o fa-2x"
                        title="Close"
                        style={{ size: "15px" }}
                        aria-hidden="true"
                        onClick={() => {
                          props.onClose();
                        }}
                      ></i>
                    </div>
                  </div>
                </div>
              </DialogContentText>
              {/* ******************************************** Email */}

              <Grid
                container
                xl={12}
                lg={12}
                md={12}
                sm={12}
                xs={12}
                justifyContent="space-between"
                alignItems="center"
                // className="bg-warning"
                // ml={4}
              >
                <Grid item xl={6} lg={6} md={6} sm={6} container my={1}>
                  <Grid item lg={4} md={4} sm={4} mt={1}>
                    Influencer Name :
                  </Grid>
                  <Grid item lg={7} md={7} sm={7}>
                    <Field
                      variant="outlined"
                      id="influencer_name"
                      as={MuiTextField}
                      size="small"
                      name="influencer_name"
                      placeholder="Influencer name"
                      error={
                        Boolean(errors.influencer_name) &&
                        Boolean(touched.influencer_name)
                      }
                      helperText={
                        Boolean(touched.influencer_name) &&
                        errors.influencer_name
                      }
                    />
                  </Grid>
                </Grid>

                {!props.edit ? (
                  <Grid item xl={6} lg={12} md={12} sm={12} container my={1}>
                    <Grid item lg={4} md={4} sm={4} mt={1}>
                      Password :
                    </Grid>
                    <Grid item lg={7} md={7} sm={7}>
                      <Field
                        variant="outlined"
                        size="small"
                        as={MuiTextField}
                        type={showPassword ? "text" : "password"}
                        id="value"
                        name="credentials[0].value"
                        placeholder="Password"
                        error={Boolean(
                          getIn(touched, "credentials") &&
                            getIn(errors, "credentials")
                        )}
                        helperText={
                          getIn(touched, "credentials") &&
                          getIn(errors, "credentials")
                        }
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <IconButton size="small">
                                <LockIcon transform="scale(0.8)" />
                              </IconButton>
                            </InputAdornment>
                          ),

                          onKeyPress: (event) => {
                            const { key } = event;
                            if (key === "Enter") {
                              buttonForLoginRef.current.click();
                            }
                          },

                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={handleClickShowPassword}
                                onMouseDown={handleMouseDownPassword}
                                edge="end"
                                size="small"
                                sx={{ mr: 1 }}
                              >
                                {showPassword ? (
                                  <VisibilityOff transform="scale(0.8)" />
                                ) : (
                                  <Visibility transform="scale(0.8)" />
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                      {/* <ErrorMessage name="credentials[0].value"></ErrorMessage> */}
                    </Grid>
                  </Grid>
                ) : null}

                <Grid item xl={6} lg={6} md={6} sm={6} container my={1}>
                  <Grid item lg={4} md={4} sm={4} mt={1}>
                    FirstName :
                  </Grid>
                  <Grid item lg={7} md={7} sm={7}>
                    <Field
                      variant="outlined"
                      id="firstName"
                      as={MuiTextField}
                      size="small"
                      name="firstName"
                      placeholder="FirstName"
                      error={Boolean(
                        getIn(touched, "firstName") &&
                          getIn(errors, "firstName")
                      )}
                      helperText={
                        getIn(touched, "firstName") &&
                        getIn(errors, "firstName")
                      }
                    />
                  </Grid>
                </Grid>

                <Grid item xl={6} lg={6} md={6} sm={6} container my={1}>
                  <Grid item lg={4} md={4} sm={4} mt={1}>
                    LastName :
                  </Grid>
                  <Grid item lg={7} md={7} sm={7}>
                    <Field
                      variant="outlined"
                      id="lastName"
                      as={MuiTextField}
                      size="small"
                      name="lastName"
                      placeholder="LastName"
                      error={Boolean(
                        getIn(touched, "lastName") && getIn(errors, "lastName")
                      )}
                      helperText={
                        getIn(touched, "lastName") && getIn(errors, "lastName")
                      }
                    />
                  </Grid>
                </Grid>

                <Grid item xl={6} lg={6} md={6} sm={6} container my={1}>
                  <Grid item lg={4} md={4} sm={4} mt={1}>
                    Contact Number:
                  </Grid>
                  <Grid item lg={7} md={7} sm={7}>
                    <Field
                      type="tel"
                      variant="outlined"
                      id="contact_number"
                      as={MuiTextField}
                      size="small"
                      name="contact_number"
                      placeholder="Contact number"
                      error={Boolean(
                        getIn(touched, "contact_number") &&
                          getIn(errors, "contact_number")
                      )}
                      helperText={
                        getIn(touched, "contact_number") &&
                        getIn(errors, "contact_number")
                      }
                    />
                  </Grid>
                </Grid>

                <Grid item lg={6} md={6} sm={6} container my={1}>
                  <Grid item lg={4} md={4} sm={4} mt={1}>
                    Email :
                  </Grid>
                  <Grid item lg={7} md={7} sm={7}>
                    <Field
                      variant="space-evenly"
                      size="small"
                      id="email_address"
                      as={MuiTextField}
                      name="email_address"
                      placeholder="Email Address"
                      error={Boolean(
                        getIn(touched, "email_address") &&
                          getIn(errors, "email_address")
                      )}
                      helperText={
                        getIn(touched, "email_address") &&
                        getIn(errors, "email_address")
                      }
                    />
                  </Grid>
                </Grid>

                <Grid item xl={6} lg={6} md={6} sm={6} container my={1}>
                  <Grid item lg={4} md={4} sm={4} mt={1}>
                    Location :
                  </Grid>
                  <Grid item lg={7} md={7} sm={7}>
                    <Field
                      variant="outlined"
                      id="location"
                      as={MuiTextField}
                      size="small"
                      name="location"
                      placeholder="Location"
                      error={
                        Boolean(errors.location) && Boolean(touched.location)
                      }
                      helperText={Boolean(touched.location) && errors.location}
                    />
                  </Grid>
                </Grid>

                <Grid item xl={6} lg={6} md={6} sm={6} container my={1}>
                  <Grid item lg={4} md={4} sm={4} mt={1}>
                    Influencer Score:
                  </Grid>
                  <Grid item lg={7} md={7} sm={7}>
                    <Field
                      type="number"
                      variant="outlined"
                      id="influencer_score"
                      as={MuiTextField}
                      size="small"
                      name="influencer_score"
                      placeholder="Influencer Score"
                      // inputProps={{ min: 0, max: 10 }}
                      error={Boolean(
                        getIn(touched, "influencer_score") &&
                          getIn(errors, "influencer_score")
                      )}
                      helperText={
                        getIn(touched, "influencer_score") &&
                        getIn(errors, "influencer_score")
                      }
                    />
                  </Grid>
                </Grid>

                <Grid item xl={6} lg={6} md={6} sm={6} container my={1}>
                  <Grid item lg={4} md={4} sm={4} mt={1}>
                    Languages :
                  </Grid>
                  <Grid item lg={7} md={7} sm={7}>
                    <Field
                      variant="outlined"
                      id="languages"
                      as={MuiTextField}
                      size="small"
                      name="languages"
                      placeholder="Languages"
                      error={
                        Boolean(errors.languages) && Boolean(touched.languages)
                      }
                      helperText={
                        Boolean(touched.languages) && errors.languages
                      }
                    />
                  </Grid>
                </Grid>

                <Grid item xl={6} lg={6} md={6} sm={6} container my={1}>
                  <Grid item lg={4} md={4} sm={4} mt={1}>
                    Description :
                  </Grid>
                  <Grid item lg={7} md={7} sm={7}>
                    <Field
                      className={
                        touched.influencer_description &&
                        errors.influencer_description
                          ? "ticket_desc_test_area_error"
                          : "ticket_desc_test_area"
                      }
                      name="influencer_description"
                      component="textarea"
                      value={values.influencer_description}
                      onChange={handleChange}
                      type="text"
                      maxRows={3}
                      minRows={3}
                      aria-label="maximum height"
                      placeholder="Description"
                      label="description"
                    />
                    <Box px={1}>
                      <ErrorMessage name="influencer_description" />
                    </Box>

                    {/* <Field
                      variant="outlined"
                      size="small"
                      id="influencer_description"
                      as={MuiTextField}
                      name="influencer_description"
                      placeholder="Description"
                      error={Boolean(
                        getIn(touched, "influencer_description") &&
                          getIn(errors, "influencer_description")
                      )}
                      helperText={
                        getIn(touched, "influencer_description") &&
                        getIn(errors, "influencer_description")
                      }
                    /> */}
                  </Grid>
                </Grid>

                <Grid item xl={6} lg={6} md={6} sm={6} container my={1}>
                  <Grid item lg={4} md={4} sm={4} mt={1}>
                    Age :
                  </Grid>
                  <Grid item lg={7} md={7} sm={7}>
                    <Field
                      variant="outlined"
                      id="age"
                      type="number"
                      as={MuiTextField}
                      size="small"
                      name="age"
                      placeholder="Age"
                      error={Boolean(
                        getIn(touched, "age") && getIn(errors, "age")
                      )}
                      helperText={getIn(touched, "age") && getIn(errors, "age")}
                    />
                  </Grid>
                </Grid>

                <Grid item xl={6} lg={6} md={6} sm={6} container my={1}>
                  <Grid item lg={4} md={4} sm={4} mt={1}>
                    Audience Size:
                  </Grid>
                  <Grid item lg={7} md={7} sm={7}>
                    <Field
                      type="number"
                      variant="outlined"
                      id="audience_size"
                      as={MuiTextField}
                      size="small"
                      name="audience_size"
                      placeholder="Audience Size"
                      error={Boolean(
                        getIn(touched, "audience_size") &&
                          getIn(errors, "audience_size")
                      )}
                      helperText={
                        getIn(touched, "audience_size") &&
                        getIn(errors, "audience_size")
                      }
                    />
                  </Grid>
                </Grid>

                <Grid item xl={6} lg={6} md={6} sm={6} container my={1}>
                  <Grid item lg={4} md={4} sm={4} mt={1}>
                    Total Post:
                  </Grid>
                  <Grid item lg={7} md={7} sm={7}>
                    <Field
                      type="number"
                      variant="outlined"
                      id="total_post"
                      as={MuiTextField}
                      size="small"
                      name="total_post"
                      placeholder="Total Post"
                      error={Boolean(
                        getIn(touched, "total_post") &&
                          getIn(errors, "total_post")
                      )}
                      helperText={
                        getIn(touched, "total_post") &&
                        getIn(errors, "total_post")
                      }
                    />
                  </Grid>
                </Grid>

                <Grid item xl={6} lg={6} md={6} sm={6} container my={1}>
                  <Grid item lg={4} md={4} sm={4} mt={1}>
                    Pricing :
                  </Grid>
                  <Grid item lg={7} md={7} sm={7}>
                    <Field
                      type="number"
                      variant="outlined"
                      id="pricing"
                      as={MuiTextField}
                      size="small"
                      name="pricing"
                      placeholder="Pricing"
                      error={Boolean(
                        getIn(touched, "pricing") && getIn(errors, "pricing")
                      )}
                      helperText={
                        getIn(touched, "pricing") && getIn(errors, "pricing")
                      }
                    />
                  </Grid>
                </Grid>

                {props.statuslist.length === 1 ? null : (
                  <Grid item xl={6} lg={6} md={6} sm={6} container>
                    <Grid item lg={4} md={4} sm={4} mt={3}>
                      Status :
                    </Grid>
                    <Grid item lg={7} md={7} sm={7}>
                      <Field
                        component={AutoCompleteMultiSelect}
                        size="small"
                        options={props.statuslist ? props.statuslist : []}
                        // disabled={props.statuslist.length === 1 ? true : false}
                        value={values.status ? values.status : null}
                        name="status"
                        textFieldProps={{
                          margin: "normal",
                          variant: "outlined",
                          placeholder: "Status",
                        }}
                        isOptionEqualToValue={(option, value) =>
                          //setting value property to custom value
                          option.status_name === value.status_name
                        }
                        getOptionLabel={(option) => option.status_name}
                        error={Boolean(
                          getIn(touched, "status") && getIn(errors, "status")
                        )}
                        helperText={
                          getIn(touched, "status") && getIn(errors, "status")
                        }
                      />
                    </Grid>
                  </Grid>
                )}

                {props.organization_array.length === 1 ? null : (
                  <Grid item xl={6} lg={6} md={6} sm={6} container>
                    <Grid item lg={4} md={4} sm={4} mt={3}>
                      Organization :
                    </Grid>
                    <Grid item lg={7} md={7} sm={7}>
                      <Field
                        component={AutoCompleteMultiSelect}
                        size="small"
                        options={
                          props.organization_array
                            ? props.organization_array
                            : []
                        }
                        disabled={
                          props.organization_array.length === 1 ? true : false
                        }
                        value={values.organization ? values.organization : null}
                        isOptionEqualToValue={(option, value) =>
                          //setting value property to custom value
                          option.organization_name === value.organization_name
                        }
                        getOptionLabel={(option) => option.organization_name}
                        name="organization"
                        textFieldProps={{
                          margin: "normal",
                          variant: "outlined",
                          placeholder: "Organization",
                        }}
                        error={Boolean(
                          getIn(touched, "organization") &&
                            getIn(errors, "organization")
                        )}
                        helperText={
                          getIn(touched, "organization") &&
                          getIn(errors, "organization")
                        }
                      />
                    </Grid>
                  </Grid>
                )}
                {props.category_array.length === 1 ? null : (
                  <Grid item xl={6} lg={6} md={6} sm={6} container mb={2}>
                    <Grid item lg={4} md={4} sm={4} mt={3}>
                      Category :
                    </Grid>
                    <Grid
                      item
                      lg={7}
                      md={7}
                      sm={7}
                      style={{ position: "relative" }}
                    >
                      <Field
                        style={{
                          position: "absolute",
                          width: "100%",
                          zIndex: 999,
                        }}
                        component={AutoCompleteMultiSelect}
                        size="small"
                        options={
                          props.category_array ? props.category_array : []
                        }
                        value={values.category ? values.category : null}
                        multiple
                        limitTags={1}
                        disabled={
                          props.category_array.length === 1 ? true : false
                        }
                        isOptionEqualToValue={(option, value) =>
                          //setting value property to custom value
                          option.category_name === value.category_name
                        }
                        getOptionLabel={(option) => option.category_name}
                        name="category"
                        textFieldProps={{
                          margin: "normal",
                          variant: "outlined",
                          placeholder: !values.category.length
                            ? "Category"
                            : null,
                        }}
                        error={Boolean(
                          getIn(touched, "category") &&
                            getIn(errors, "category")
                        )}
                        helperText={
                          getIn(touched, "category") &&
                          getIn(errors, "category")
                        }
                      />
                    </Grid>
                  </Grid>
                )}

                <Grid item xl={6} lg={6} md={6} sm={6} container mb={2}>
                  <Grid item lg={4} md={4} sm={4} mt={3}>
                    Platforms :
                  </Grid>
                  <Grid
                    item
                    lg={7}
                    md={7}
                    sm={7}
                    style={{ position: "relative" }}
                  >
                    <Field
                      style={{
                        position: "absolute",
                        width: "100%",
                        zIndex: 999,
                      }}
                      component={AutoCompleteMultiSelect}
                      size="small"
                      multiple
                      limitTags={1}
                      options={props.platformList ? props.platformList : []}
                      disabled={props.platformList.length === 1 ? true : false}
                      name="social_media_platforms"
                      textFieldProps={{
                        margin: "normal",
                        variant: "outlined",
                        placeholder: !values.social_media_platforms.length
                          ? "Platform"
                          : null,
                      }}
                      isOptionEqualToValue={(option, value) =>
                        //setting value property to custom value
                        option.platform_name === value.platform_name
                      }
                      getOptionLabel={(option) => option.platform_name}
                      error={Boolean(
                        getIn(touched, "social_media_platforms") &&
                          getIn(errors, "social_media_platforms")
                      )}
                      helperText={
                        getIn(touched, "social_media_platforms") &&
                        getIn(errors, "social_media_platforms")
                      }
                    />
                  </Grid>
                </Grid>

                <Grid itemxl={6} lg={6} md={6} sm={6} container>
                  <Grid item lg={4} md={4} sm={4} mt={3}>
                    Gender :
                  </Grid>
                  <Grid item lg={7} md={7} sm={7}>
                    <Field
                      component={AutoCompleteMultiSelect}
                      size="small"
                      options={["Male", "Female", "Others"]}
                      name="gender"
                      textFieldProps={{
                        margin: "normal",
                        variant: "outlined",
                        placeholder: "Gender",
                      }}
                      error={Boolean(
                        getIn(touched, "gender") && getIn(errors, "gender")
                      )}
                      helperText={
                        getIn(touched, "gender") && getIn(errors, "gender")
                      }
                    />
                  </Grid>
                </Grid>

                <Grid item xl={6} lg={6} md={6} sm={6} container>
                  <Grid item lg={4} md={4} sm={4} mt={3}>
                    Marital Status :
                  </Grid>
                  <Grid item lg={7} md={7} sm={7}>
                    <Field
                      component={AutoCompleteMultiSelect}
                      size="small"
                      options={MartialArray}
                      name="marital_status"
                      textFieldProps={{
                        margin: "normal",
                        variant: "outlined",
                        placeholder: "Martial Status",
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>

              <FormControlLabel
                control={<Checkbox checked={values.enabled} />}
                label="Enable/Disable"
                name="enabled"
                value={values.enabled}
                onChange={handleChange}
              />

              <Box
                mt={1}
                sx={{
                  width: "100%",
                  boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.16)",
                }}
              >
                <Accordion
                  sx={
                    {
                      // backgroundColor:"#f3f9fb"
                    }
                  }
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <h4>Custom Ticket Fields</h4>
                  </AccordionSummary>
                  <AccordionDetails
                    sx={{
                      width: "100%",
                      height: 220,
                      overflow: "auto",
                      overscrollBehaviorY: "contain",
                    }}
                  >
                    {values.custom_value &&
                      values.custom_value.map((item, index) => {
                        if (item.field_type === "text") {
                          return (
                            <Grid
                              item
                              xl={12}
                              lg={12}
                              laptop={12}
                              md={12}
                              sm={12}
                              mt={1}
                              key={index}
                              // className="bg-warning"
                              container
                              justifyContent={"center"}
                              alignItems="center"
                            >
                              <Grid
                                lg={3}
                                md={2}
                                sm={2}
                                mt={1}
                                // className="bg-success"
                              >
                                <label htmlFor={item.field_name}>
                                  {item.field_name} {" :"}
                                </label>
                              </Grid>
                              <Grid lg={8} md={10} sm={10}>
                                <Field
                                  id={item.field_id}
                                  name={`custom_value.${index}.field_values[0].value`}
                                  render={({ field }) => (
                                    <MuiTextField
                                      name={`custom_value.${index}.field_values[0].value`}
                                      size="small"
                                      value={item.field_values[0].value}
                                      onChange={handleChange}
                                    />
                                  )}
                                  type="text"
                                  varient="outlined"
                                />
                              </Grid>
                            </Grid>
                          );
                        } else if (item.field_type === "select") {
                          return (
                            <Grid
                              item
                              xl={12}
                              lg={12}
                              laptop={12}
                              md={12}
                              sm={12}
                              mt={1}
                              container
                              justifyContent={"center"}
                              alignItems="center"
                            >
                              <Grid lg={3} md={2} sm={2} mt={3}>
                                <label htmlFor={item.field_name}>
                                  {item.field_name}
                                  {" :"}
                                </label>
                              </Grid>
                              <Grid lg={8} md={10} sm={10}>
                                <Field
                                  name={`custom_value.${index}.field_values[0]`}
                                  // value={custom_value[index].field_values[0]}
                                  component={AutoCompleteMultiSelect}
                                  options={
                                    props.customticketfields.hits &&
                                    props.customticketfields.hits.hits.filter(
                                      (e) => {
                                        return e._id === item.field_id;
                                      }
                                    ).length != 0
                                      ? props.customticketfields.hits.hits.filter(
                                          (e) => {
                                            return e._id === item.field_id;
                                          }
                                        )[0]._source.field_values
                                      : []
                                  }
                                  size="small"
                                  isOptionEqualToValue={(option, value) =>
                                    //setting value property to custom value
                                    option.value === value.value
                                  }
                                  //setting custom label to custom value
                                  getOptionLabel={(option) =>
                                    option.value ? option.value : ""
                                  }
                                  textFieldProps={{
                                    fullWidth: true,
                                    margin: "normal",
                                    variant: "outlined",
                                  }}
                                  // multiple
                                />
                              </Grid>
                            </Grid>
                          );
                        } else if (item.field_type === "toggle") {
                          return (
                            <Grid
                              item
                              xl={12}
                              lg={12}
                              laptop={12}
                              md={12}
                              sm={12}
                              mt={1}
                              container
                              justifyContent={"center"}
                              alignItems="center"
                            >
                              <Grid lg={3} md={2} sm={2} mt={1}>
                                <label htmlFor={item.field_name}>
                                  {item.field_name}
                                </label>
                                {" :"}
                              </Grid>
                              <Grid lg={8} md={10} sm={10}>
                                <FormControlLabel
                                  control={
                                    <Field
                                      component={SwitchButton}
                                      type="checkbox"
                                      name={`custom_value.${index}.field_values[0].value`}
                                      checked={
                                        item.field_values[0]
                                          ? item.field_values[0].value
                                          : null
                                      }
                                    />
                                  }
                                />
                              </Grid>
                            </Grid>
                          );
                        } else if (item.field_type === "multiselect") {
                          return (
                            <Grid
                              item
                              xl={12}
                              mt={2}
                              container
                              justifyContent={"center"}
                              alignItems="center"
                            >
                              <Grid lg={3} md={2} sm={2} mt={1}>
                                <label htmlFor={item.field_name}>
                                  {item.field_name}
                                </label>
                                {" :"}
                              </Grid>
                              <Grid lg={8} md={10} sm={10}>
                                <Field
                                  name={item.field_name}
                                  component={AutoCompleteMultiSelect}
                                  multiple
                                  label={item.field_name}
                                  size="small"
                                  options={item.field_values}
                                  isOptionEqualToValue={(option, value) =>
                                    //setting value property to custom value
                                    option.value === value.value
                                  }
                                  //setting custom label to custom value
                                  getOptionLabel={(option) => option.value}
                                  textFieldProps={{
                                    fullWidth: true,
                                    margin: "normal",
                                    variant: "outlined",
                                  }}
                                />
                              </Grid>
                            </Grid>
                          );
                        } else if (item.field_type === "date") {
                          return (
                            <Grid
                              item
                              xl={12}
                              lg={12}
                              md={12}
                              sm={12}
                              mt={2}
                              container
                              justifyContent={"center"}
                              alignItems="center"
                            >
                              <Grid lg={3} md={2} sm={2} mt={3}>
                                <label htmlFor={item.field_name}>
                                  {item.field_name}
                                </label>
                                {" :"}
                              </Grid>
                              <Grid lg={8} md={10} sm={10}>
                                <Field
                                  component={DatePickerComponent}
                                  size="small"
                                  name={`custom_value.${index}.field_values[0].value`}
                                  label={false}
                                  textFieldProps={{
                                    fullWidth: true,
                                    margin: "normal",
                                    variant: "outlined",
                                  }}
                                />
                              </Grid>
                            </Grid>
                          );
                        }
                      })}
                  </AccordionDetails>
                </Accordion>
              </Box>
            </DialogContent>

            <DialogActions>
              <Grid
                container
                item
                lg={12}
                md={12}
                sm={12}
                display="flex"
                justifyContent="space-evenly"
              >
                <Grid item lg={4.8} md={5} sm={5} mb={3}>
                  {!props.edit ? (
                    <MuiButton
                      name={"Add User"}
                      loading={loading}
                      type="submit"
                      width="100%"
                      buttonRef={buttonForLoginRef}
                    />
                  ) : (
                    <MuiButton
                      name={"Submit"}
                      loading={loading}
                      type="submit"
                      width="100%"
                      buttonRef={buttonForLoginRef}
                    />
                  )}
                </Grid>

                <Grid item lg={4.8} md={5} sm={5} mb={3}>
                  {!props.edit ? (
                    <MuiButton
                      name={"Reset"}
                      type="reset"
                      onClick={Formik.resetForm}
                      width="100%"
                    />
                  ) : (
                    <MuiButton
                      name={"Cancel"}
                      onClick={() => {
                        props.onClose();
                        Formik.resetForm();
                      }}
                      width="100%"
                    />
                  )}
                </Grid>
              </Grid>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
}

export default connect(mapDispatchToProps)(ManageInfluenceUserPost);
